module.exports = __webpack_public_path__ + "img/20200428145957TIM截图20200428144839.ac6f10f8.png";